(function () {
  'use strict';

  /*
   * "Notify me if another copy shows up" — one pre-filled entry against the
   * live want-list endpoint (see WANT_LIST_SPEC.md, snippets/vault-notify-me
   * .liquid). Much simpler than assets/vault-wantlist.js: one product, one
   * email field, one fixed want built from data attributes on the root
   * element rather than a form the shopper fills in row by row.
   *
   * EXACT MATCHING (2026-09-12): sends exact:true (a real JSON boolean,
   * per Bill's spec — the string "true" doesn't count) plus condition,
   * alongside set/number/finish. Bill's backend, deployed the same
   * evening, only matches an exact want against a product sharing the
   * same set, number, AND finish, with the same condition — closing the
   * gap this feature originally shipped with (loose set+number matching
   * only). The homepage want-list form (assets/vault-wantlist.js) never
   * sends exact, so those wants stay loose on purpose — this tightening
   * is scoped to this one sold-out prompt only.
   */

  function say(root, message, isError) {
    var box = root.querySelector('[data-notify-message]');
    if (!box) return;
    box.textContent = message;
    box.hidden = !message;
    box.classList.toggle('is-error', !!isError);
  }

  function submit(root) {
    var endpoint = root.getAttribute('data-endpoint') || '';
    var emailEl = root.querySelector('[data-notify-email]');
    var consentEl = root.querySelector('[data-notify-consent]');
    var button = root.querySelector('[data-notify-submit]');

    var email = emailEl ? emailEl.value.trim() : '';

    if (!email || email.indexOf('@') === -1) {
      say(root, 'We need a real email address to tell you if this comes back.', true);
      return;
    }
    if (consentEl && !consentEl.checked) {
      say(root, 'Tick the box so we are allowed to email you.', true);
      return;
    }
    if (!endpoint) {
      say(root, 'Sorry, this is not switched on yet. Email office@leisurebeamgames.com and we will add you by hand.', true);
      return;
    }

    var payload = {
      email: email,
      consent: consentEl ? !!consentEl.checked : false,
      consent_text: consentEl ? (consentEl.getAttribute('data-consent-text') || '') : '',
      consent_at: new Date().toISOString(),
      source_url: window.location.href,
      hp: '',
      wants: [
        {
          name: root.getAttribute('data-name') || '',
          set: root.getAttribute('data-set') || '',
          number: root.getAttribute('data-number') || '',
          finish: root.getAttribute('data-finish') || '',
          condition: root.getAttribute('data-condition') || '',
          exact: true,
          note: root.getAttribute('data-note') || ''
        }
      ]
    };

    if (button) {
      button.disabled = true;
      button.textContent = 'Sending...';
    }
    say(root, '');

    fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) {
        return r.json().then(function (b) {
          return { ok: r.ok && b && b.ok !== false, body: b };
        });
      })
      .then(function (res) {
        if (button) {
          button.disabled = false;
          button.textContent = 'Notify me if it turns up';
        }
        if (res.ok) {
          var done = root.querySelector('[data-notify-done]');
          var form = root.querySelector('[data-notify-form]');
          var consentLabel = root.querySelector('.vault-notify-me-consent');
          if (done) done.hidden = false;
          if (form) form.hidden = true;
          if (consentLabel) consentLabel.hidden = true;
          return;
        }
        say(root, (res.body && res.body.error) || 'That did not send. Please try again.', true);
      })
      .catch(function () {
        if (button) {
          button.disabled = false;
          button.textContent = 'Notify me if it turns up';
        }
        say(root, 'That did not send. Check your connection and try again.', true);
      });
  }

  function init(root) {
    if (root.dataset.notifyInit) return;
    root.dataset.notifyInit = 'true';

    root.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-notify-submit]')) {
        e.preventDefault();
        submit(root);
      }
    });
  }

  function scan() {
    document.querySelectorAll('[data-vault-notify-me]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  document.addEventListener('shopify:section:load', scan);
})();
